/** @jsxImportSource @emotion/react */

import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import { data } from '../Data/index';
import { Metadata } from '../Metadata/metadata';

export const Head = () => {
  return (
    <BrowserRouter basename="/2020">
      <Switch>
        <Route exact path="/">
          <Metadata title={data.page.title} description={data.page.description} imageSrc={data.page.image.src} />
        </Route>

        {data.cards.map((card) => (
          <Route key={`route-${card.slug}-key`} path={`/${card.slug}`}>
            {/* If the snapshots are happening, use the specialized metadata. Otherwise, redirect the user to the homepage. */}
            {navigator.userAgent === 'ReactSnap' ? (
              <Metadata title={card.socialMediaTitle} description={card.socialMediaDescription} imageSrc={card.socialMediaImage.src} />
            ) : (
              <Redirect to="/" />
            )}
          </Route>
        ))}
      </Switch>
    </BrowserRouter>
  );
};

Head.displayName = 'Head';
